import { RoutablePage, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Emit, Component, Mixins } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_QUERY, USER_LOGOUT_KEYCLOAK } from '@gig/magic-messages';
import { notificationService, NotificationStyle } from '@gig/magic-messaging';
import { isPAGCOR } from '@gig/magic-jurisdictions/dist/jurisdictions.constants';
import { CoreXSelfExcludeDuration } from '@gig/magic-sdk/dist/adapter/responsiblegaming/createUserSuspensionLimit';

var SelfExclude = /** @class */ (function (_super) {
    __extends(SelfExclude, _super);
    function SelfExclude() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.confirmation = false;
        _this.selectedDuration = null;
        _this.currentJurisdiction = null;
        return _this;
    }
    SelfExclude.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, window.queryBus.query(USER_JURISDICTION_QUERY)];
                    case 1:
                        _a.currentJurisdiction = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SelfExclude.prototype, "durations", {
        get: function () {
            if (this.currentJurisdiction && isPAGCOR(this.currentJurisdiction)) {
                return [
                    CoreXSelfExcludeDuration.SIX_MONTHS,
                    CoreXSelfExcludeDuration.TWELVE_MONTHS,
                    CoreXSelfExcludeDuration.SIXTY_MONTHS,
                ];
            }
            return Object.keys(CoreXSelfExcludeDuration)
                .filter(function (key) { return isNaN(Number(key)); })
                .map(function (key) {
                return CoreXSelfExcludeDuration[key];
            });
        },
        enumerable: false,
        configurable: true
    });
    SelfExclude.prototype.selfExclude = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, magic.methods.responsibleGaming.createUserSuspensionLimitSelfExclude(this.selectedDuration)];
                    case 1:
                        _a.sent();
                        notificationService.show(this.$t('self-exclude.notification.text'), {
                            style: NotificationStyle.SUCCESS,
                            uniqueID: 'self-exclude-notification-text',
                        });
                        window.commandBus.publish(USER_LOGOUT_KEYCLOAK, this.getFullHref({ route: RoutablePage.HOME }));
                        return [2 /*return*/, this.selectedDuration];
                    case 2:
                        error_1 = _a.sent();
                        notificationService.show("" + error_1.$, {
                            style: NotificationStyle.ERROR,
                        });
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SelfExclude.prototype.getDurationLabel = function (duration) {
        return this.$t("time-out." + duration + ".label") || 'Indefinitely';
    };
    __decorate([
        Emit('self-exclude'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], SelfExclude.prototype, "selfExclude", null);
    SelfExclude = __decorate([
        Component({
            name: 'corex-self-exclude',
        })
    ], SelfExclude);
    return SelfExclude;
}(Mixins(MagicConfigMixin)));

export default SelfExclude;
